import { isEmpty } from '@shared/utils/type'
import { REGEX } from '@shared/const/regex.const'

export const FORM_FIELD_VIEW = {
  STUB_TEXT: 'hidden',
  VIEW_HIDDEN: 'view-hidden',
  TEXT: 'text',
  TEXTAREA: 'textarea',
  NUMBER: 'number',
  PHONE: 'phone',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  PERSONAL_DATA_AGREEMENT: 'personal-data-agreement',
  PROFILE_PUBLICATION_AGREEMENT: 'profile-publication-agreement',
  CHECKBOX_IMAGES: 'images',
  DROPZONE: 'dropzone',
  DADATA_ORG: 'dadata-organisation',
  DADATA_CITY: 'dadata-city',
  DATEPICKER: 'date-picker',
  SELECT: 'select',
}

export const FORM_FIELD_TYPE = {
  USER_AGREEMENT: -1, //пользовательское соглашение
  STRING: 1, // Текстовое поле (одна строка)
  TEXTAREA: 2, // Текстовое поле (Несколько строк)
  NUMBER: 3, // Цифровое поле (с валидацией)
  EMAIL: 4, // E-mail с валидацией
  DATE: 5, // Дата (календарь)
  FILE: 6, // Загрузка файла
  SELECT_ONE: 7, // Выпадающий список с одним вариантом
  SELECT_MULTI: 8, // Выпадающий список с несколькими вариантами
  CHECKBOX_GROUP: 9, // Варианты ответов в виде чекбоксов
  CHECKBOX_IMAGE_GROUP: 10, // Варианты ответов в виде картинок
  PHONE: 11, // Номер телефона
  STUB_TEXT: 12, // Поле заглушка. Для текстовых подсказок
  URL: 13, // Ссылка
  SELECT_RADIO: 14, // Радио-баттон
  DADATA_STRING_CITY: 15, // Текстовое поле (одна строка + dadata город)
  DADATA_STRING_COMPANY: 16, // Текстовое поле (одна строка + dadata компании)
  VIEW_HIDDEN: 17, // Скрытое поле
  TEXT_RU_COM: 18, // Текстовое поле (с валидацией RU и COM)
  TEXT_ONE_LINE: 19, // Текстовое поле (одна строка с валидацией [а-Я, a-Z])
  SELECT_SEARCHABLE: 20, // Выпадающий список с поиском
}

export const FORM_ADD_PARAMS = {
  readonlyIfPrefilled: 'readonlyIfPrefilled', // дизейблинг предзаполненных полей, value?: string
  hasEmail: 'hasEmail', // для проверки дубликатов заявки по email, value: "/api/form/hasemail"
  checkEmail: 'checkEmail', // для проверки email на "Домены исключенные из регистраций" из настроек, value: "/api/form/checkemail"
  blockedValues: 'blockedValues', // не допустимые значения, value: { values: string[], subField?: string, message: string }
  fieldProps: 'fieldProps', // пропсы для компонентов value: json_object
  maximum: 'maximum', // value: json_object, список задач в рамках AX-297 TODO убрать после АХ максимума
}

export const FORM_FIELD_PROPS = {
  contextFormPath: 'contextFormPath', // путь поля в контексте формы
  preloadImmediately: 'preloadImmediately', // boolean, загружать начальный список (компонент UiAsyncSelect)
  minSearchLength: 'minSearchLength', // number, минимальное количество символов для поиска (компонент UiAsyncSelect)
}

export const FORM_FIELD_DEFAULT_SPAN = 4

export const FORM_FIELD_MAX_SPAN = 12

export const FORM_SELECT_TYPE = {
  SINGLE: 'single',
  MULTI: 'multi',
}

export function resolveFieldValue(field, formContext) {
  if (
    [FORM_FIELD_TYPE.DADATA_STRING_COMPANY, FORM_FIELD_TYPE.DADATA_STRING_CITY].includes(field.typeField) &&
    field?.isAuth &&
    formContext?.isAuth
  ) {
    return null
  }

  if (!isEmpty(field.value)) {
    return field.value
  }

  if (field.defaultValue) {
    return field.defaultValue
  }

  if (field.type === FORM_FIELD_VIEW.SELECT) {
    return resolveSelectType(field.typeField) === FORM_SELECT_TYPE.MULTI ? [] : null
  }

  if (field.type === FORM_FIELD_VIEW.RADIO) {
    return 1
  }

  if ([FORM_FIELD_VIEW.CHECKBOX, FORM_FIELD_VIEW.CHECKBOX_IMAGES, FORM_FIELD_VIEW.DROPZONE].includes(field.type)) {
    return []
  }

  if ([FORM_FIELD_VIEW.TEXT, FORM_FIELD_VIEW.TEXTAREA, FORM_FIELD_VIEW.PHONE, FORM_FIELD_VIEW.DATEPICKER].includes(field.type)) {
    return ''
  }

  return null
}

export const DEFAULT_EXTRA_FIELD_NAMES = ['id', 'placeId', 'nameEntity', 'entityId']

export const PROFILE_PUBLICATION_AGREEMENT = {
  id: 'profilePublicationAgreement',
  name: 'profilePublicationAgreement',
  value: false,
  disabled: false,
  requiredField: true,
  type: FORM_FIELD_VIEW.PROFILE_PUBLICATION_AGREEMENT,
  typeField: FORM_FIELD_TYPE.USER_AGREEMENT,
  width: FORM_FIELD_MAX_SPAN,
}

export const PERSONAL_DATA_AGREEMENT = {
  id: 'personalDataAgreement',
  name: 'personalDataAgreement',
  value: false,
  disabled: false,
  requiredField: true,
  type: FORM_FIELD_VIEW.PERSONAL_DATA_AGREEMENT,
  typeField: FORM_FIELD_TYPE.USER_AGREEMENT,
  width: FORM_FIELD_MAX_SPAN,
}

export const DEFAULT_AGREEMENTS = [PERSONAL_DATA_AGREEMENT]

export function resolveDisableState(field, formContext) {
  if (hasReadonlyIfPrefilled(field, formContext)) {
    return !isEmpty(field.value)
  }

  return !isEmpty(field?.disabled) ? field.disabled : false
}

export function hasReadonlyIfPrefilled(field, formContext) {
  return field.addParams?.hasOwnProperty(FORM_ADD_PARAMS.readonlyIfPrefilled) && formContext.isAuth
}

export function resolveSelectType(typeField) {
  switch (Number(typeField)) {
    case FORM_FIELD_TYPE.SELECT_MULTI:
      return FORM_SELECT_TYPE.MULTI

    default:
      return FORM_SELECT_TYPE.SINGLE
  }
}

export function resolveTypeField(field, formContext) {
  if (
    [FORM_FIELD_TYPE.DADATA_STRING_COMPANY, FORM_FIELD_TYPE.DADATA_STRING_CITY].includes(field.typeField) &&
    field?.isAuth &&
    formContext?.isAuth
  ) {
    return FORM_FIELD_TYPE.STRING
  }

  return field.typeField
}

export function resolveType(field, formContext) {
  if (
    [FORM_FIELD_TYPE.DADATA_STRING_COMPANY, FORM_FIELD_TYPE.DADATA_STRING_CITY].includes(field.typeField) &&
    field?.isAuth &&
    formContext?.isAuth
  ) {
    return FORM_FIELD_VIEW.TEXT
  }

  if (field.type) {
    return field.type
  }

  switch (Number(field.typeField)) {
    case FORM_FIELD_TYPE.STRING:
    case FORM_FIELD_TYPE.EMAIL:
    case FORM_FIELD_TYPE.URL:
    case FORM_FIELD_TYPE.TEXT_RU_COM:
    case FORM_FIELD_TYPE.TEXT_ONE_LINE:
      return FORM_FIELD_VIEW.TEXT

    case FORM_FIELD_TYPE.TEXTAREA:
      return FORM_FIELD_VIEW.TEXTAREA

    case FORM_FIELD_TYPE.NUMBER:
      return FORM_FIELD_VIEW.NUMBER

    case FORM_FIELD_TYPE.PHONE:
      return FORM_FIELD_VIEW.PHONE

    case FORM_FIELD_TYPE.DATE:
      return FORM_FIELD_VIEW.DATEPICKER

    case FORM_FIELD_TYPE.FILE:
      return FORM_FIELD_VIEW.DROPZONE

    case FORM_FIELD_TYPE.SELECT_ONE:
    case FORM_FIELD_TYPE.SELECT_MULTI:
    case FORM_FIELD_TYPE.SELECT_SEARCHABLE:
      return FORM_FIELD_VIEW.SELECT

    case FORM_FIELD_TYPE.CHECKBOX_GROUP:
      return FORM_FIELD_VIEW.CHECKBOX

    case FORM_FIELD_TYPE.CHECKBOX_IMAGE_GROUP:
      return FORM_FIELD_VIEW.CHECKBOX_IMAGES

    case FORM_FIELD_TYPE.SELECT_RADIO:
      return FORM_FIELD_VIEW.RADIO

    case FORM_FIELD_TYPE.STUB_TEXT:
      return FORM_FIELD_VIEW.STUB_TEXT

    case FORM_FIELD_TYPE.VIEW_HIDDEN:
      return FORM_FIELD_VIEW.VIEW_HIDDEN

    case FORM_FIELD_TYPE.DADATA_STRING_CITY:
      return FORM_FIELD_VIEW.DADATA_CITY

    case FORM_FIELD_TYPE.DADATA_STRING_COMPANY:
      return FORM_FIELD_VIEW.DADATA_ORG

    default:
      return FORM_FIELD_VIEW.TEXT
  }
}

export function resolveFieldPatternAndMessage(field, formContext) {
  switch (field.typeField) {
    case FORM_FIELD_TYPE.STRING:
    case FORM_FIELD_TYPE.TEXTAREA:
    case FORM_FIELD_TYPE.DATE:
    case FORM_FIELD_TYPE.PHONE:
      return [REGEX.STRING_FROM_2_SYMBOLS, 'Введите хотя бы 2 непробельных символа подряд']

    case FORM_FIELD_TYPE.DADATA_STRING_CITY:
    case FORM_FIELD_TYPE.DADATA_STRING_COMPANY:
      return field.isAuth && formContext.isAuth ? [REGEX.STRING_FROM_2_SYMBOLS, 'Введите хотя бы 2 непробельных символа подряд'] : []

    case FORM_FIELD_TYPE.NUMBER:
      return [REGEX.NUMBER, 'Допустимы только цифры']

    case FORM_FIELD_TYPE.EMAIL:
      return [formContext.isRU ? REGEX.MAIL_WITH_RU : REGEX.MAIL, 'Некорректный email-адрес']

    case FORM_FIELD_TYPE.URL:
      return [REGEX.LINK, 'Некорректная ссылка']

    case FORM_FIELD_TYPE.TEXT_RU_COM:
      return formContext.isRU
        ? [REGEX.PERSON_TEXT_RU, 'Используйте только русские буквы, пробелы и дефисы']
        : [REGEX.PERSON_TEXT_COM, 'Incorrect value']

    case FORM_FIELD_TYPE.TEXT_ONE_LINE:
      return [REGEX.ONLY_CHAR, 'Только буквы, минимум 2, без пробелов и дефисов']

    default:
      return []
  }
}

export const DROPZONE_OPTIONS = {
  url: 'callbackBecomeVendor',
  autoQueue: false,
  thumbnailWidth: 80,
  thumbnailHeight: 80,
  maxFiles: 12, // максимальное количество файлов
  maxFilesize: 10, // максимальный вес одного файла, MB
  addRemoveLinks: true,
  dictRemoveFile: '×',
  acceptedFiles: '.jpg,.jpeg,.png,.docx,.doc,.pdf,.txt,.tif,.svg',
  dictFileTooBig: 'Файл слишком большой. Максимальный размер файла: {{maxFilesize}} MB.',
  dictInvalidFileType: 'Вы не можете загружать файлы этого типа.',
  dictMaxFilesExceeded: 'Вы не можете больше загружать файлы.',
}

export const DEFAULT_PHONE_MASK = '+7(111)111-11-11'



// WEBPACK FOOTER //
// ./src/modules/shared/const/form/form.field.js